import React from 'react';
import { useIntl } from 'react-intl';
import { useSelector } from 'react-redux';

import { useTheme } from '../../ThemeContext';

import Helmet from '../../components/Helmet';
import Header from '../../components/Header';
import Sider from '../../components/Sider';
import DashboardPanel from '../../components/DashboardPanel';

import {
  Section,
  Wrapper,
  Content,
  Panel,
  PanelInner,
  Information,
  Center,
  Text,
  Box,
} from './DashboardPage.style';

const DashboardPage = () => {
  const intl = useIntl();
  const theme = useTheme();
  const { profile } = useSelector((state) => state.firebase);
  const isProfileCompany = profile.company && profile.company.id ? true : false;

  const renderInformation = (information) => {
    return (
      <Center>
        <Information theme={theme.content.information.default}>
          <Text>{information}</Text>
        </Information>
      </Center>
    );
  };

  const renderPanelBox = () => {
    return (
      <Box>
        <DashboardPanel />
      </Box>
    );
  };

  return (
    <>
      <Helmet title={intl.formatMessage({ id: 'PAGE_TITLE.DASHBOARD' })} />
      <Section>
        <Sider />
        <Wrapper>
          <Header title={intl.formatMessage({ id: 'PAGE_TITLE.DASHBOARD' })} />
          <Content>
            <Panel theme={theme.content.panel.default}>
              <PanelInner>
                {!isProfileCompany
                  ? renderInformation(
                      intl.formatMessage({
                        id: `DASHBOARD.YOU_HAVE_NO_ASSIGNED_COMPANY`,
                      })
                    )
                  : renderPanelBox()}
              </PanelInner>
            </Panel>
          </Content>
        </Wrapper>
      </Section>
    </>
  );
};

export default DashboardPage;
